import { defaultTheme, TextFieldTheme } from '@medly-components/theme';

import colors from './colors';

const defaultBorderWidth = '0.15rem';

const defaultOutlined = {
    borderWidth: defaultBorderWidth,
    borderRadius: '0.4rem'
};

export const textField: TextFieldTheme = {
    ...defaultTheme.textField,
    outlined: {
        default: {
            bgColor: colors.grey[100],
            borderColor: colors.grey[600],
            borderRadius: defaultOutlined.borderRadius,
            borderWidth: defaultOutlined.borderWidth,
            helperTextColor: colors.grey[700],
            iconColor: colors.grey[600],
            labelColor: colors.grey[600],
            textColor: colors.darkBlue,
            placeholderColor: colors.grey[600]
        },
        hover: {
            borderColor: colors.darkBlue,
            borderWidth: defaultOutlined.borderWidth,
            shadowColor: colors.grey[600],
            iconColor: colors.darkBlue
        },
        disabled: {
            labelColor: colors.grey[400],
            textColor: colors.grey[500],
            borderColor: colors.grey[300],
            bgColor: colors.white,
            cursor: 'not-allowed',
            iconColor: colors.grey[400]
        },
        active: {
            bgColor: colors.white,
            borderColor: colors.darkBlue,
            borderRadius: defaultOutlined.borderRadius,
            borderWidth: defaultOutlined.borderWidth,
            labelColor: colors.grey[700],
            placeholderColor: colors.grey[300],
            shadowColor: colors.darkBlue,
            iconColor: colors.darkBlue
        },
        error: {
            bgColor: colors.white,
            caretColor: colors.error,
            placeholderColor: colors.grey[300],
            cursorColor: colors.error,
            borderColor: colors.error,
            labelColor: colors.error,
            helperTextColor: colors.error,
            shadowColor: colors.error,
            iconColor: colors.error
        }
    }
};
